import * as firebase from 'firebase'

export default {
  state: {
    loadedUsers: []
  },
  getters: {
    loadedUsers (state) {
      return state.loadedUsers
    },
    loadedUser (state) {
      return (userId) => {
        return state.loadedUsers.find(user => {
          return user.id === userId
        })
      }
    }
  },
  // synchronous
  mutations: {
    setLoadedUsers (state, payload) {
      state.loadedUsers = payload
    },
    createUser (state, payload) {
      state.loadedUsers.push(payload)
    },
    updateUser (state, payload) {
      const user = state.loadedUsers.find(user => {
        return user.id === payload.id
      })
      console.log(user)
    }
  },
  // asynchronous
  actions: {
    loadUsers ({ commit }) {
      console.log('load users here')
      commit('clearError')
      commit('setLoading', true)
      firebase.database().ref('users').once('value')
        .then(data => {
          const users = []
          const obj = data.val()
          for (let key in obj) {
            users.push({
              id: key,
              name: obj[key].name,
              email: obj[key].email,
              createdAt: obj[key].createdAt,
              createdById: obj[key].createdById,
              createdByEmail: obj[key].createdByEmail
            })
          }
          commit('setLoadedUsers', users)
          commit('setLoading', false)
        })
        .catch(err => {
          console.log(err)
          commit('setLoading', false)
          commit('setError', err.message)
        })
    },
    createUser ({ commit, getters }, payload) {
      console.log('createUser')
      commit('clearError')
      commit('setLoading', true)
      const newUser = {
        // createdAt: Date.now(),
        createdAt: firebase.database.ServerValue.TIMESTAMP,
        email: payload.email,
        createdById: getters.user.id,
        createdByEmail: getters.user.email
      }
      firebase.database().ref('users').push(newUser)
        .then(data => {
          console.log(data)
          commit('createUser', {
            ...newUser,
            id: data.key
          })
          commit('setLoading', false)
        })
        .catch(err => {
          console.log(err)
          commit('setLoading', false)
          commit('setError', err.message)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/user/index.js